import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.sidebar = document.getElementById("AiSidebar")
    this.scrollToBottomBtn = document.getElementById("scroll-to-bottom-btn")
    this.updateVisibility()
  }

  updateVisibility() {
    if (!this.sidebar) return

    // Check if sidebar is explicitly opened (has d-flex class)
    const isExplicitlyOpen = this.sidebar.classList.contains("d-flex")

    // Check viewport width - at 1024px+, sidebar-default-visible shows sidebar
    const isLargeViewport = window.innerWidth >= 1024
    const hasDefaultVisible = this.sidebar.classList.contains("sidebar-default-visible")
    const sidebarIsVisible = isExplicitlyOpen || (isLargeViewport && hasDefaultVisible)

    if (sidebarIsVisible) {
      this.sidebar.classList.add("open")
      this.sidebar.classList.remove("closed")
      this.scrollToBottomBtn?.classList.remove("d-none")
    } else {
      this.sidebar.classList.add("closed")
      this.sidebar.classList.remove("open")
      this.scrollToBottomBtn?.classList.add("d-none")
    }

    // Button visibility is controlled by CSS at smaller viewports
    // At 1024px+, hide button when sidebar is visible
    if (isLargeViewport && sidebarIsVisible) {
      this.buttonTarget.classList.add("d-none")
    } else if (isLargeViewport) {
      this.buttonTarget.classList.remove("d-none")
    }
    // Below 1024px, CSS handles button visibility
  }

  toggleSidebar() {
    if (!this.sidebar) return

    // Toggle d-flex class to explicitly open/close sidebar
    if (this.sidebar.classList.contains("d-flex")) {
      this.sidebar.classList.remove("d-flex")
    } else {
      this.sidebar.classList.add("d-flex")
    }

    this.updateVisibility()
  }

  showSidebar() {
    if (!this.sidebar) return

    // Only open sidebar on mobile
    const isLargeViewport = window.innerWidth >= 1024
    if (isLargeViewport) return

    this.sidebar.classList.add("d-flex")
    this.updateVisibility()
  }
}
